import { eventsSenderWithPerfomance } from 'globalState/global-state.js';

interface ProductData {
    id: string;
    name: string;
    price: number;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
}

export const loadProduct = ({ productData }: { productData: ProductData }) => {
    eventsSenderWithPerfomance('card', 'card', {
        ...productData,
        source: 'card',
    });

    if (window.dataLayer) {
        const product = {
            index: 0,
            item_id: productData.id,
            item_name: productData.name,
            item_category: productData.item_category,
            item_category2: productData.item_category2,
            item_category3: productData.item_category3,
            price: productData.price,
            quantity: 1,
        };

        window.dataLayer.push({
            'event': 'view_item',
            'ecommerce': {
                'currencyCode': 'RUB',
                'value': productData.price,
                'items': [product],
            },
        });
    }
};

export const linkToMarketplace = ({ source }: { source: string }) => {
    try {
        if (source === 'ozon') {
            window.ym(process.env.YM_COUNTER_ID, 'reachGoal', 'transition_to_ozon')
        } else if (source === 'wildberries') {
            window.ym(process.env.YM_COUNTER_ID, 'reachGoal', 'transition_to_wb')
        }
    } catch (error) {
        console.error(error);
    }
};
